import VeeValidate from 'vee-validate';

VeeValidate.Validator.extend('DL#IL', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{11,12}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#OR', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9a-zA-Z]{1,9}|[a-zA-Z]{1}[0-9]{6})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#AL', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{1,7}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#AK', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{1,7}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#AZ', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[0-9]{8}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#AR', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{4,9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#CA', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{7}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#CO', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([0-9]{9}$|[a-zA-Z]{1}[0-9]{3,6}|[a-zA-Z]{2}[0-9]{2,5})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#CT', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#DE', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{1,7}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#DC', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{7}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#FL', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{12}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#GA', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{7,9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#HI', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[0-9]{8}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#ID', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{2}[0-9]{6}[a-zA-Z]{1}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#IN', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[0-9]{9}|[0-9]{9}|[0-9]{10})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#IA', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{9}|[0-9]{3}[a-zA-Z]{2}[0-9]{4})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#KS', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}|[a-zA-Z]{1}[0-9]{8}|[0-9]{9})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#KY', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{8}|[a-zA-Z]{1}[0-9]{9}|[0-9]{9})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#LA', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{1,9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#ME', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{7}|[0-9]{7}[a-zA-Z]{1}|[0-9]{8})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MD', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{12}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MA', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[0-9]{8}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MI', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{10}|[a-zA-Z]{1}[0-9]{12})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MN', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{12}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MS', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MO', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{5,9}|[a-zA-Z]{1}[0-9]{6}R|[0-9]{8}[a-zA-Z]{2}|[0-9]{9}[a-zA-Z]{1}|[0-9]{9})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#MT', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{8}|[0-9]{13}|[0-9]{9}|[0-9]{14})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NE', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{6,8}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NV', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{9}|[0-9]{10}|[0-9]{12}|X[0-9]{8})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NH', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{2}[a-zA-Z]{3}[0-9]{5}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NJ', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{14}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NM', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{8,9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NY', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{7}|[a-zA-Z]{1}[0-9]{18}|[0-9]{8}|[0-9]{9}|[0-9]{16}|[a-zA-Z]{8})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#NC', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{1,12}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#ND', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{3}[0-9]{6}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#OH', {
  validate: value => {
    var strongRegex = new RegExp(
      '^([a-zA-Z]{1}[0-9]{4,8}|[a-zA-Z]{2}[0-9]{3,7}|[0-9]{8})$'
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#OK', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[0-9]{9}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#PA', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{8}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#RI', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{7}|[a-zA-Z]{1}[0-9]{6})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#SC', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{5,11}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#SD', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{6,10}|[0-9]{12})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#TN', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{7,9}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#TX', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{7,8}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#UT', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{4,10}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#VT', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{8}|[0-9]{7}A)$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#VA', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[0-9]{8,11}|[0-9]{9})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#WA', {
  validate: value => {
    var strongRegex = new RegExp('^([a-zA-Z]{1}[a-zA-Z0-9*]{11})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#WV', {
  validate: value => {
    var strongRegex = new RegExp('^([0-9]{7}|[a-zA-Z]{1,2}[0-9]{5,6})$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#WI', {
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z]{1}[0-9]{13}$');
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('DL#WY', {
  validate: value => {
    var strongRegex = new RegExp('^[0-9]{9,10}$');
    return strongRegex.test(value);
  }
});
